<script>
import alertDescriptions from '../../model/v1/slotAlerts';
import ConsecutiveShiftsLimitIcon from '../icons/ConsecutiveShiftsLimitIcon.vue';
import InsufficientVacationIcon from '../icons/InsufficientVacationIcon.vue';
import MonthlyShiftLimitIcon from '../icons/MonthlyShiftLimitIcon.vue';
import NGStaffPairingIcon from '../icons/NGStaffPairingIcon.vue';
import PaperPlaneIcon from '../icons/PaperPlaneIcon.vue';
import UnassignedStaffIcon from '../icons/UnassignedStaffIcon.vue';

export default {
  props: {
    numReadComments: Number,
    numUnreadComments: Number,
    isClone: Boolean,
    shouldShowAlert: {
        type: Boolean,
        default: false,
    },
    alertIndex: {
        type: Number,
        default: 0,
    },
    askStatus: {
        type: Number,
        default: 0,
    },
    tooltipBottom: Boolean,
  },
  computed: {
    slotTopRightStyle() {
        return {
            'right': this.tooltipBottom ? '-2px' : '',
        }
    },
    displayUnreadCommentsCount() {
        return this.numUnreadComments > 9 ? '9+' : this.numUnreadComments;
    },
    displayReadCommentsCount() {
        return this.numReadComments > 9 ? '9+' : this.numReadComments;
    },
    displayReadCommentBadge() {
        return this.numReadComments && !this.isClone;
    },
    isAsked() {
        return this.askStatus > 0;
    },
    askedBadgeClass() {
        return {
            'asked-badge-accepted': this.askStatus === 2,
            'asked-badge-rejected': this.askStatus === 3,
        }
    },
    askedSlotTooltipText() {
        return this.askStatus === 3 ? '要請が承認されませんでした' : '要請';
    },
    alertDescription() {
        return this.alertIndex ? alertDescriptions[this.alertIndex] : "";
    },
  },
  components: {
    PaperPlaneIcon,
    UnassignedStaffIcon,
    ConsecutiveShiftsLimitIcon,
    MonthlyShiftLimitIcon,
    InsufficientVacationIcon,
    NGStaffPairingIcon,
  }
};
</script>

<template>
    <!-- Top Right Slot Badges -->
    <div class="slot-top-right" :style="slotTopRightStyle">
        <span v-if="numUnreadComments" class="circle-container comment-number-badge">{{ displayUnreadCommentsCount }}</span>
        <span v-else-if="displayReadCommentBadge" class="circle-container comment-number-badge comment-read-badge">{{ displayReadCommentsCount }}</span>

        <span v-if="isAsked" class="tooltip tooltip-left text-warning circle-container asked-badge" :class="askedBadgeClass" :data-tooltip="askedSlotTooltipText">
            <PaperPlaneIcon class="text-light"/>
        </span> 

        <span v-if="shouldShowAlert" class="tooltip tooltip-left circle-container alert-badge" :data-tooltip="alertDescription">
            <UnassignedStaffIcon v-if="alertIndex === 1"/>
            <ConsecutiveShiftsLimitIcon v-else-if="alertIndex === 2"/>
            <MonthlyShiftLimitIcon v-else-if="alertIndex === 3"/>
            <InsufficientVacationIcon v-else-if="alertIndex === 4"/>
            <NGStaffPairingIcon v-else-if="alertIndex === 5"/>
            <i v-else-if="alertIndex === 6" class="zmdi zmdi-close zmdi-hc-lg"></i>
            <div v-else>!</div>
        </span>
    </div>
</template>

<style scoped>
.comment-read-badge {
  background-color: #B1BABE;
}
</style>
